module.exports = __webpack_public_path__ + "static/media/cancelled.1ea6b848.svg";